import React, { useContext } from "react";
import { Spin, List, Button } from "antd";
import DetailLayout from "../../components/DetailLayout";
import { CourseContext } from "../../Store";
import DetailLayoutHeader from "../../components/DetailLayout/components/DetailLayoutHeader";
import useDeviceType from "../../../../Utils/useDeviceType";
import styles from "./index.module.scss";
import useRequest from "../../../../Utils/useRequest";
import { getMeetingActivity } from "../service";
import { useParams } from "react-router-dom";
import img from "./img/img.png";
import PreviewSourceModal from "../../../../components/PreviewSourceModal";
import { FILETYPE_LIST } from "../../../../API/teams";
import useModalHandler from "../../../../Utils/v2/useModalHandler";
import { ListProps } from "../../../../components/PreviewSourceModal/servers";

const Index = () => {
    const { course } = useContext(CourseContext);
    const { isPC } = useDeviceType();
    const { meetingId } = useParams();

    const [data, { loading }, reload] = useRequest(
        () =>
            getMeetingActivity({
                meetingId: meetingId || "",
                weekTimeId: course.weekTimeId
            }),
        {},
        [course.weekTimeId, meetingId]
    );

    const prevModal = useModalHandler(PreviewSourceModal);

    function onPrev(id: number) {
        prevModal.setPayload(id);
        const lists: ListProps[] =
            data?.recording.map(item => {
                return {
                    id: parseInt(item.id),
                    fileType: item.name?.split(".").pop() || "",
                    fileUrl: item.fileKey,
                    fileName: item.name
                };
            }) || [];
        prevModal.setList(lists);
        prevModal.open();
    }

    return (
        <DetailLayout breadcrumb="会议详情" title="会议详情">
            {isPC && <DetailLayoutHeader title={data?.title || ""} />}
            <Spin spinning={loading}>
                <div className={styles.main}>
                    <h3 className={styles.title}>
                        会议信息{" "}
                        <a
                            href={data?.url}
                            className={styles.href}
                            target="_blank"
                            rel="noreferrer">
                            (点我入会)
                        </a>
                    </h3>
                    <p className={styles.text}>{data?.text}</p>
                    <h3 className={styles.title}>回放视频</h3>
                    <List
                        itemLayout="horizontal"
                        dataSource={data?.recording}
                        renderItem={item => (
                            <List.Item
                                actions={[
                                    <Button
                                        type="link"
                                        onClick={() =>
                                            onPrev(parseInt(item.id))
                                        }>
                                        查看
                                    </Button>
                                ]}>
                                <List.Item.Meta
                                    avatar={
                                        <img className={styles.img} src={img} />
                                    }
                                    title={
                                        <p className={styles.record}>
                                            {item.name}
                                        </p>
                                    }
                                />
                            </List.Item>
                        )}
                    />
                </div>
            </Spin>

            {prevModal.render(
                <PreviewSourceModal
                    zIndex={1100}
                    FILETYPE_LIST={FILETYPE_LIST}
                />
            )}
        </DetailLayout>
    );
};

export default Index;
